export default __webpack_public_path__ + "static/media/runnerup2.49db0043.jpg";